module.exports = __webpack_public_path__ + "static/media/image_4_extra.be95f133.jpg";